// This should be removed when using real validations for DIRECT / COLLECTION / DISTRIBUTION
export const validationSchemaForDirect = {
  working_day: ['7:00', '19:00'],
};
